import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Form, Modal } from 'antd'
import { Empty } from 'packages/components/Empty'
import { paperApi } from 'packages/sdks-next/growp'
import { Ellipsis, Radio, Toast } from '@seiue/ui'
import { InputSearch } from 'packages/components/InputSearch'

/**
 * 引用试卷弹窗
 *
 * @param param - 参数
 * @param param.visible - 是否可见
 * @param param.setPaperId - 选中试卷
 * @param param.onClose - 关闭弹窗回调
 * @param param.isRand - 是否已读
 * @returns React.ReactNode
 */
export const QuotePaper: React.FC<{
  visible: boolean
  onClose: () => void
  onOk: (v: number) => void
  isRand?: boolean
}> = ({ visible, onClose, isRand, onOk }) => {
  const [form] = Form.useForm()
  const [temporaryPaperId, setTemporaryPaperId] = useState<number>()
  const [searchKey, setSearchKey] = useState<string>()

  const { data, loading, reload } = paperApi.useQueryPapers({
    paginated: 0,
    nameLike: searchKey,
    noCopy: false,
    isRand: !!isRand,
  })

  useEffect(() => {
    if (visible) {
      reload()
    }
  }, [visible])

  return (
    <Modal
      open={visible}
      title="引用试卷"
      width={640}
      bodyStyle={{
        height: '385px',
        padding: '20px 20px 0 20px',
      }}
      onCancel={() => {
        onClose()
        form.resetFields()
      }}
      onOk={() => {
        if (!form.getFieldValue('paperId')) {
          Toast.warning('请先选择试卷')
          return
        }
        onOk(form.getFieldValue('paperId'))
        form.resetFields()
      }}
      okText="引用"
    >
      <div>
        <InputSearch
          placeholder="搜索试卷名称"
          onPressEnter={(e) => {
            const v = (e.target as HTMLInputElement).value
            setSearchKey(v)
          }}
          onClear={() => setSearchKey(undefined)}
        />
      </div>
      <div
        style={{
          width: '100%',
          height: '328px',
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        {data && data.length > 0 ? (
          <Form form={form}>
            <Form.Item name="paperId">
              <Radio.Group
                onChange={(e) => setTemporaryPaperId(e.target.value)}
                value={temporaryPaperId}
              >
                {data?.map((i) => {
                  return (
                    <Radio
                      key={i.id}
                      value={i.id}
                    >
                      <PaperListItem>
                        <div style={{ width: '350px' }}>
                          <Ellipsis text={i.name} />
                        </div>
                        <div>
                          {i.updatedAt
                            ? `修改时间：${i.updatedAt}`
                            : `创建时间：${i.createdAt}`}
                        </div>
                      </PaperListItem>
                    </Radio>
                  )
                })}
              </Radio.Group>
            </Form.Item>
          </Form>
        ) : (
          <>
            {loading ? null : (
              <div style={{ marginTop: '120px' }}>
                <Empty />
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  )
}

const PaperListItem = styled.div`
  width: 570px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div:first-child {
    font-size: 14px;
    color: ${(props) => props.theme.text._1};
  }
  & > div:last-child {
    width: 200px;
    font-size: 12px;
    color: ${(props) => props.theme.text._3};
  }
`
